export function debounce(fn, timeout) {
    // console.log('call: ext debounce:', fn, timeout);
    var tm = null;
    function wrapper(...args) {
        // console.log('call: int debounce', tm);
        if (tm) { clearTimeout(tm); }
        tm = setTimeout(() => {
            // console.log('call: handler debounce', fn, args);
            fn.apply(null, args);
        }, timeout);
    };
    wrapper.cancel = () => (tm && clearTimeout(tm));
    return wrapper;
}

export default debounce;